import application from 'application/application';

const controller = 'KeywordsListController';

application.controller(controller, [
	'$scope',
	'$state',
	'$stateParams',
	'helper',
	'$http',
	'API',
	($scope, $state, $stateParams, helper, $http, API) => {
		$scope.filter = $.extend({}, $stateParams);

		$scope.groupUserSelected = localStorage.getItem('__groupSelected__');
		$scope.hasGroup = localStorage.getItem('__hasGroup__');

		$scope.userData = JSON.parse(
			localStorage.getItem('__authenticationUserData__')
		);

		if ($scope.groupUserSelected === 'true' && $scope.hasGroup === 'true')
			$scope.groupData = JSON.parse(localStorage.getItem('__groupUserData__'));

		const { palavraChave, caderno, diario } = $stateParams;

		$scope.hasFilters = !!palavraChave || !!caderno || !!diario;

		$scope.allKeyword = helper.responseStore();
		$scope.allDiaries = helper.responseStore();
		$scope.allNotebooks = helper.responseStore();

		$scope.paginaAtual = $stateParams.paginaAtual;

		$scope.consultarPalavraChave = () => {
			if (!$stateParams.palavraChave) return;

			$http({
				...helper.http(API.briefcase, 'keywords'),
				method: 'GET',
				params: {
					...helper.httpFields(['idPalavraChave', 'nomePasta']),
					idPalavraChave: $stateParams.palavraChave,
					registrosPorPagina: 10,
					paginaAtual: 1,
					IdGrupo: $scope.groupData && $scope.groupData.idGrupo
				}
			}).then(
				response => ($scope.palavraChaveSelecionada = response.data.itens)
			);
		};

		$scope.consultarPalavraChave();

		$scope.recordKeyWordsBriefcase = responsestore => {
			responsestore.setReady(false);
			$scope.allDiaries.setReady(false);
			$scope.allNotebooks.setReady(false);

			let requestParams = {
				campos: '*',
				paginaAtual: $stateParams.paginaAtual ? $stateParams.paginaAtual : 1,
				registrosPorPagina: 20,
				idGrupo: $scope.groupData && $scope.groupData.idGrupo,
				IdDiario: $stateParams.diario,
				IdCaderno: $stateParams.caderno,
				IdPalavraChave: $stateParams.palavraChave && $stateParams.palavraChave
			};

			$http({
				...helper.http(API.briefcase, 'keywords'),
				params: requestParams
			})
				.then(response => {
					if (!response.data.itens) {
						responsestore.setReady(true);
						$scope.allDiaries.setReady(true);
						$scope.allNotebooks.setReady(true);

						return;
					}

					const {
						paginaAtual,
						paginaTotal,
						registrosTotal
					} = response.data.paginacao;

					$scope.paginaAtual = paginaAtual;
					$scope.paginaTotal = paginaTotal;
					$scope.registrosTotal = registrosTotal;
					$scope.hasNext = $scope.paginaAtual < $scope.paginaTotal;

					responsestore.setItems(response.data.itens);

					$scope.recordDiaries($scope.allDiaries);
				})
				.finally(() => responsestore.setReady(true));
		};

		$scope.recordKeyWordsBriefcase($scope.allKeyword);

		$scope.recordDiaries = responseStore => {
			responseStore.setReady(false);

			$http({
				...helper.http(API.diaries, 'searchPublication'),
				params: {
					IdsPalavraChave: $stateParams.palavraChave,
					IdGrupoUsuarios: $scope.groupData && $scope.groupData.idGrupo
				}
			})
				.then(response => {
					const {
						data: { itens }
					} = response;

					itens.sort((a, b) => a.nomeDiario.localeCompare(b.nomeDiario));

					responseStore.setItems(itens);

					if ($stateParams.diario) {
						$scope.recordNotebooks($scope.allNotebooks, $stateParams.diario);
						$scope.disableNotebooks = true;
					}
				})
				.finally(() => {
					// let diariesIds = responseStore
					// 	.getItems()
					// 	.map(({ idDiario }) => idDiario);

					//$scope.diariesIds = diariesIds;

					// $scope.recordNotebooks($scope.allNotebooks, diariesIds);

					responseStore.setReady(true);
				});
		};

		$scope.recordNotebooks = (responsestore, allDiariesId) => {
			if (!$scope.allDiaries.getItems().length > 0) {
				responsestore.setItems([]);
				responsestore.setReady(true);

				return;
			}

			$http({
				...helper.http(API.notebook, 'GET'),
				params: {
					...helper.httpFields(['*']),
					IdsDiario: $stateParams.diario
						? $stateParams.diario
						: allDiariesId && allDiariesId.join().trim(),
					Ativo: true
				}
			})
				.then(({ data: { itens } }) => {
					if (itens)
						itens.sort((a, b) => a.descricao.localeCompare(b.descricao));

					responsestore.setItems(itens);
				})
				.finally(() => {
					$scope.disableNotebooks = false;

					responsestore.setReady(true);
				});
		};

		$scope.changeKeywordFilter = filters => {
			setTimeout(() => {
				let value =
					$('#btnFilterByKeyword').attr('ng-custom-model') ||
					$('#btnFilterByKeywordSelected').attr('ng-custom-model');

				filters.palavraChave = value;

				$scope.filterKeywords(filters);
			}, 100);
		};

		// $scope.updateQuantityPerPage = (quantityPerPage) => {
		// 	if ($scope.idQtdItensPagina) {
		// 		$http({
		// 			...helper.http(API.itemsPerPageQuantity),
		// 			method: 'PUT',
		// 			data: {
		// 				itens: [
		// 					{
		// 						id: $scope.idQtdItensPagina,
		// 						qtdRegistroMovPorPagina: quantityPerPage || 20
		// 					}
		// 				]
		// 			},
		// 			messageOverride: {
		// 				success() {
		// 				}
		// 			}
		// 		}).then(() => {
		// 			$state.go($state.current.name, {
		// 				paginaAtual: 1
		// 			}, {
		// 				inherit: false,
		// 				reload: $state.current.name
		// 			});
		// 		});
		// 	} else {
		// 		$http({
		// 			...helper.http(API.itemsPerPageQuantity),
		// 			method: 'POST',
		// 			data: {
		// 				itens: [
		// 					{
		// 						qtdRegistroMovPorPagina: quantityPerPage || 20
		// 					}
		// 				]
		// 			},
		// 			messageOverride: {
		// 				success() {
		// 				}
		// 			}
		// 		}).then(() => {
		// 			$state.go($state.current.name, {
		// 				paginaAtual: 1
		// 			}, {
		// 				inherit: false,
		// 				reload: $state.current.name
		// 			});
		// 		});
		// 	}
		// };

		$scope.filterKeywords = filters => {
			$scope.disableNotebooks = true;
			filters.paginaAtual = 1;

			if ($stateParams.palavraChave !== filters.palavraChave)
				filters['diario'] = null;
			if ($stateParams.diario !== filters.diario) filters['caderno'] = null;

			setTimeout(() => {
				$state.go($state.current.name, filters);
			}, 250);

			// if ($stateParams.diario) {
			// 	$scope.recordNotebooks($scope.allNotebooks, $stateParams.diario);
			// }

			// $scope.recordNotebooks($scope.allNotebooks, diariesIds);
		};

		$scope.clearFilter = function(f, arr) {
			arr.map(item => {
				f[item] = undefined;
			});

			$scope.filterKeywords($scope.filter);
		};

		$scope.recordProcessPaginate = direction => {
			let page;

			if (direction == 'next')
				page = $stateParams.paginaAtual
					? Number($stateParams.paginaAtual) + 1
					: 2;
			else if (direction == 'prev')
				page = $stateParams.paginaAtual
					? Number($stateParams.paginaAtual) - 1
					: 1;
			else if (direction == 'last') page = $scope.paginaTotal;
			else page = 1;

			$state.go(
				$state.current.name,
				{
					paginaAtual: page
				},
				{
					inherit: false,
					reload: true
				}
			);
		};
	}
]);

export default controller;
